/**
 * vet-visit-header.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { parseISO } from 'date-fns';
import { Types } from 'utils/constants';
import useRecordStore from 'contexts/record-store';
import RouteLink from 'routing/route-link';
import Icon from 'components/icon';
import Row from '../row/row';
import RowLocationDate from '../row/row-location-date';



const useStyles = makeStyles(theme => ({
  root: {
    transition: `${theme.transitions.duration.shorter}ms ${theme.transitions.easing.easeOut}`,
    backgroundColor: theme.palette.comp.recordRow.vet.background,
    '&:hover': {
      backgroundColor: theme.palette.comp.recordRow.headerHover(theme.palette.comp.recordRow.vet.background)
    }
  }
}));


const VetVisitHeader = React.memo(function (props) {
  const {
    id,
    basePath,
  } = props;
  const classes = useStyles();
  const recordStore = useRecordStore();
  const classRecord = recordStore.useRecord(Types.Record.VET_VISIT, id).ornull;

  if (!classRecord) return null;

  const vetVisit = classRecord.get();
  const date = parseISO(vetVisit.date);

  const routeLink = <RouteLink
    basePath={basePath}
    pathSectionName='vetVisit'
    pathItemName='view'
    pathParams={{ vetVisitId: id }}
    className='absolute-fill recordLink'
  />;


  return (
    <>
      <Row
        data-testid={id}
        data-testtype='header-vet-visit'
        recordType={Types.Record.VET_VISIT}
        isHeader
        className={`header ${classes.root}`}
        routeLink={routeLink}
        icon={<Icon type='vet-visit' />}
        textVariant='body2'
        title='Vet Visit'
        detail={<RowLocationDate
          location={vetVisit.location || 'no address'}
          date={date}
        />}
        optional={<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {vetVisit.dog.name}
        </div>}
      />
    </>
  )
}, (prev, next) => {
  return (
    prev.id === next.id
  );
});

export default VetVisitHeader;